import type { PopupData } from 'webapp-types';

import ClientMetricsEditComponent from 'webapp/components/client/metrics/edit';
import PopupInnerModalComponent from 'webapp/components/popup/inner/modal';

export default class MetricsPopupCustomFormatComponent extends PopupInnerModalComponent<PopupData.ClientMetrics.Edit> {
	get onlySourceOfType() {
		return this.popupData.onlySourceOfType;
	}
	<template>
		<div class="title">
			Set up account metric
		</div>

		<div class="content {{if this.onlySourceOfType 'oneLine'}}">
			<ClientMetricsEditComponent
				@model={{this.popupData.model}}
				@spaceId={{this.popupData.spaceId}}
				@position={{this.popupData.position}}
				@onlySourceOfType={{this.onlySourceOfType}}
				@onClose={{this.close}}
				@onRecenter={{this.reposition}}
				@hideOptionToSelectDimensions={{this.popupData.hideOptionToSelectDimensions}}
			/>
		</div>
	</template>
}
